export default __webpack_public_path__ + "assets/images/66747f6b869f92502b89390316fce4bc.svg";